import React, { useMemo, useRef, useState, useEffect } from 'react';
import { Circle, GoogleMap, InfoWindow, Marker, Polygon, useJsApiLoader, OverlayView } from '@react-google-maps/api';
// import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from '@react-google-maps/api';
import './mapview.css'
import Sidebar from '../Components/Sidebar/Sidebar';
import { Form, Dropdown } from 'react-bootstrap';
import BootstrapTable from "react-bootstrap-table-next";
import pagination from "./pagination";
import {
  getcoordinatesData,
  getactivestaff,
  getZone,
  getstafflistwithlatlang,
  updatelatlonginbooking
} from '../Api/bookingApi';
import moment from "moment-timezone";
import { SITE_URL } from '../Api/config';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from 'react-bootstrap/Spinner';
import { DateRangePicker } from 'react-date-range';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import ChildComponent from '../Components/EditUser/Informasi';
import BookingComponent from "../Bookingdata/Appointment"

import { notify } from "../utils/notify";
import {
    GREEN_FROG_ZONES,
    sanDiegoCoords,
    laMesaCoords,
    powayCoords,
    carlsbadCoords,
    orangeCountyCoords,
} from "./MapData";




function MapView() {



    const [staffList, setStaffList] = useState(null);
    const [selectedStaff, setSelectedStaff] = useState(0);
    const [datePreset, setDatePreset] = useState('Today');
    const [moreFiltersOpen, setMoreFiltersOpen] = useState(false);
    const [mapLoadState, setMapLoadState] = useState('loading');
    const [refreshKey, setRefreshKey] = useState(0);
    const latestMapRequest = useRef(0);

    const [changestaffzone, setchangesstaffzone] = useState('');
    const [selectedZones, setSelectedZones] = useState([]);
    const [bookingzonelist, setBookingzonelist] = useState([]);

    const [loadingsppiner, setLoadingSpinner] = useState(false);

    // const today = new Date();
    const today = moment.tz('America/Los_Angeles').toDate();
    const [sdate, setSdate] = useState(today);
    const sevenDaysLater = new Date();
    // const [edate, setEdate] = useState(sevenDaysLater.setDate(sevenDaysLater.getDate() + 7));
    const [edate, setEdate] = useState(today);

    const [show9, setShow9] = useState(false);

    const handleClose9 = () => setShow9(false);
    const handleShow9 = () => setShow9(true);


    const [colorLegend, setColorLegend] = useState({}); // stores key → color


    const [showDateDisplay, setShowDateDisplay] = useState(false);

    const [dates, setDates] = useState([
        {
            startDate: new Date(),
            endDate: today,
            key: 'selection'
        }
    ]);


    const zoneStyleByName = (name) => {
        // You can tweak colors per zone here
        const map = {
            "San Diego": { fillColor: "#FFD700" },
            "La Mesa": { fillColor: "#FF0000" },
            "Poway": { fillColor: "#00FF00" },
            "Carlsbad": { fillColor: "#0000FF" },
            "Orange County": { fillColor: "#FF00FF" },
        };
        return {
            fillColor: map[name]?.fillColor || "#7C9EFF",
            fillOpacity: 0.40,
            strokeColor: "#FFA500",
            strokeOpacity: 1,
            strokeWeight: 2,
        };
    };




    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyA9PRZ4LU9yTqlpV6d7-GH11B70BZKVJOU"
    })

    const center = { lat: 32.7460124, lng: -117.1274174 };


    const getAddress = async (lat, lng) => {
        const apiKey = 'AIzaSyA9PRZ4LU9yTqlpV6d7-GH11B70BZKVJOU'; // Replace with your Google Maps API key
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch data from API');
            }
            const data = await response.json();
            if (data.status === 'OK') {
                return data.results[0]?.formatted_address || 'Address not found';
            } else {
                throw new Error(`Geocoding API error: ${data.status}`);
            }
        } catch (error) {
            console.error('Error fetching address:', error.message);
            return 'Error fetching address';
        }
    };

    const handleStaffMarker = (marker) => {
        // if (marker === activeMarker) {
        //   return;
        // } 
        getAddress(marker.lat, marker.lang)
            .then(address => setAddress(address))
            .catch(error => setAddress('Error fetching address'));

        setStaffHoveredMarker(marker);
    };

    const [activeMarker, setActiveMarker] = useState(null);

    const [map, setMap] = React.useState(null)

    const onLoad = React.useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);

        setMap(map)
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])


    const getStaffList = () => {
        getactivestaff().then((res) => {
            if (res.code === 200) {
                const apiResponse = res.data;
                setStaffList(apiResponse.data);
            }
        })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallzone = () => {
        getZone().then((response) => {
            if (response.code === 200) {
                if (response.data.status === "1") {
                    setBookingzonelist(response.data.data);
                } else {
                    setBookingzonelist([]);
                }
            } else {
                setBookingzonelist([]);
            }
        }).catch((error) => {
            setBookingzonelist([]);
        });
    }

    const [staffscoordinates, setStaffsCoordinates] = useState([]);


    const getstafflistwithlatlangfunc = () => {
        const formData = new FormData();
        formData.append("selectedStaff", selectedStaff);
        getstafflistwithlatlang(formData).then((response) => {
            if (response.code === 200) {
                if (response.data.status === "1") {
                    setStaffsCoordinates(response.data.data);
                } else {
                    setStaffsCoordinates([])
                }
            } else {
                setStaffsCoordinates([])
            }
        }).catch((error) => {
            setStaffsCoordinates([])
        });
    }

    useEffect(() => {
        getStaffList();
        getallzone();
        getstafflistwithlatlangfunc();
    }, []);

    const isSingleDay = moment(sdate).isSame(edate, 'day');

    const [isOn, setIsOn] = useState(true);


    const [groupBy, setGroupBy] = useState('date'); // 'date' | 'technician'

    function getUniqueDateColorMap(data) {
        // Generate a random hex color
        const getRandomHexColor = () => {
            const rand = () => Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
            return `#${rand()}${rand()}${rand()}`;
        };

        const dateSet = new Set();

        // Collect unique dates in YYYY-MM-DD format
        data.forEach(item => {
            const dateOnly = item.order_date?.split(' ')[0]; // safely extract date part
            if (dateOnly) {
                dateSet.add(dateOnly);
            }
        });

        const dateArray = Array.from(dateSet).sort();
        const colorMap = {};

        // Assign each date a unique color
        dateArray.forEach(date => {
            colorMap[date] = getRandomHexColor();
        });

        return colorMap;
    }



    function CustomHTMLMarker(position, staffId, map, onClick, markercolor) {
        class HTMLMarker extends window.google.maps.OverlayView {
            constructor(position, staffId, map, onClick) {
                super();
                this.position = position;
                this.staffId = staffId;
                this.map = map;
                this.onClick = onClick;
                this.div = null;
                this.setMap(map);
            }

            onAdd() {
                this.div = document.createElement("div");
                this.div.style.position = "absolute";
                this.div.style.transform = "translate(-50%, -50%)";
                this.div.style.padding = "4px 10px";
                this.div.style.background = markercolor;
                // this.div.style.border = "1px solid #000";
                this.div.style.borderRadius = "16px";
                this.div.style.fontSize = "12px";
                this.div.style.fontWeight = "bold";
                // this.div.style.boxShadow = "0px 2px 6px rgba(0, 0, 0, 0.2)";
                this.div.style.cursor = "pointer";
                this.div.style.userSelect = "none";
                this.div.innerHTML = this.staffId;

                this.div.addEventListener("click", () => {
                    if (this.onClick) this.onClick();
                });

                const panes = this.getPanes();
                panes.overlayMouseTarget.appendChild(this.div);
            }

            draw() {
                const projection = this.getProjection();
                const point = projection.fromLatLngToDivPixel(this.position);
                if (point && this.div) {
                    this.div.style.left = point.x + "px";
                    this.div.style.top = point.y + "px";
                }
            }

            onRemove() {
                if (this.div) {
                    this.div.remove();
                    this.div = null;
                }
            }
        }

        return new HTMLMarker(position, staffId, map, onClick);
    }

    const [datescolors, setDatesColors] = useState({});

    const kmToMiles = (km) => (km * 0.621371).toFixed(2);


    const handleOnLoad = (map) => {
        const bounds = new window.google.maps.LatLngBounds(center);
        const colorMap = {};
        const markers = [];
        var datarangecolor = [];

        const isSingleDay = moment(sdate).isSame(edate, 'day');

        datarangecolor = getUniqueDateColorMap(coordinates);


        const groupByFinal = groupBy === "date" && isSingleDay ? "technician" : groupBy;

        setisSingleDayView(groupByFinal === "date" ? false : true);

        coordinates.forEach((item) => {
            var markercolor = "#0000FF"; // Default color
            if (!usableLocation(item)) return;

            const latLng = new window.google.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng));
            bounds.extend(latLng);

            isSingleDay === true ? markercolor = item.staff_colors?.[0]?.trim() :
                markercolor = datarangecolor[moment(item.order_date).format("YYYY-MM-DD")];

            //get date color map and also make unique 
            if (!datescolors[moment(item.order_date).format("YYYY-MM-DD")]) {
                setDatesColors(prevState => ({ ...prevState, [moment(item.order_date).format("YYYY-MM-DD")]: markercolor }));
            }

            const technicianId = item.staff_ids?.split(",")[0]?.trim() || "Unknown";
            const marker = new window.google.maps.Marker({
                position: latLng,
                map,
                icon: {
                    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="30">
                        <rect width="50" height="30" rx="15" ry="15" fill="${markercolor}" />
                        <text x="25" y="20" text-anchor="middle" font-size="14" fill="white" font-weight="bold">${technicianId}</text>
                    </svg>
                    `)}`,
                    scaledSize: new window.google.maps.Size(50, 30), // no pin shape
                    anchor: new window.google.maps.Point(25, 15) // perfectly center
                },
                animation: window.google.maps.Animation.DROP,
                title: `${item.name} | Technician ID: ${technicianId}`,
            });

            marker.addListener("click", () => setActiveMarker(item));
            markers.push(marker);
        });

        setColorLegend(colorMap);
        map.fitBounds(bounds);
    };


    // const handleOnLoad = (map) => {
    //     const bounds = new window.google.maps.LatLngBounds();
    //     const markers = [];
    //     let datarangecolor = [];

    //     const isSingleDay = moment(sdate).isSame(edate, 'day');
    //     datarangecolor = getUniqueDateColorMap(coordinates); // user-defined function

    //     const groupByFinal = groupBy === "date" && isSingleDay ? "technician" : groupBy;
    //     setisSingleDayView(groupByFinal === "date" ? false : true);



    //     coordinates.forEach((item) => {
    //         var markercolor = "#0000FF";
    //         if (!item.lat || !item.lng) return;

    //         const latLng = new window.google.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng));
    //         bounds.extend(latLng);

    //         isSingleDay === true ? markercolor = item.staff_colors?.[0]?.trim() :
    //             markercolor = datarangecolor[moment(item.order_date).format("YYYY-MM-DD")];

    //         const staffId = item.staff_ids?.split(",")[0]?.trim() || "N/A";

    //         CustomHTMLMarker(latLng, staffId, map, () => setActiveMarker(item), markercolor);
    //     });

    //     map.fitBounds(bounds);
    // };




    const getColorByDay = (date, colorMap) => {
        const dayKey = moment(date).format("YYYY-MM-DD");
        if (!colorMap[dayKey]) {
            const hue = Math.floor(Math.random() * 360);
            colorMap[dayKey] = `hsl(${hue}, 100%, 50%)`;
        }
        return colorMap[dayKey];
    };


    const [coordinates, setCoordinates] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [displayCoordinates, setDisplayCoordinates] = useState([]);
    const [debouncedSearch, setDebouncedSearch] = useState('');
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearch(searchValue), 350);
        return () => clearTimeout(timer);
    }, [searchValue]);
    const usableLocation = booking => {
        const lat = Number(booking.lat), lng = Number(booking.lng);
        return booking.lat != null && booking.lng != null &&
            booking.lat !== '' && booking.lng !== '' &&
            Number.isFinite(lat) && Number.isFinite(lng) &&
            Math.abs(lat) <= 90 && Math.abs(lng) <= 180 &&
            !(lat === 0 && lng === 0);
    };
    const missingAppointments = displayCoordinates.filter(booking => !usableLocation(booking));
    const technicianCount = new Set(displayCoordinates.flatMap(booking =>
        String(booking.staff_ids || '').split(',').map(id => id.trim()).filter(Boolean)
    )).size;

    const handleSearch = (e) => {
        setSearchValue(e.target.value)
    }

    const [hoveredMarker, setHoveredMarker] = useState(null);
    const [staffhoveredMarker, setStaffHoveredMarker] = useState(null);


    // Map Phase 1 follows LillyPad's existing America/Los_Angeles scheduling convention.
    const applyDatePreset = preset => {
        const now = moment.tz('America/Los_Angeles');
        let start = now.clone().startOf('day');
        let end = start.clone();
        if (preset === 'Tomorrow') { start.add(1, 'day'); end = start.clone(); }
        if (preset === 'This Week' || preset === 'Next Week') {
            start = now.clone().startOf('isoWeek');
            if (preset === 'Next Week') start.add(1, 'week');
            end = start.clone().add(6, 'days');
        }
        setDatePreset(preset);
        setSdate(start.toDate());
        setEdate(end.toDate());
        setDates([{ startDate: start.toDate(), endDate: end.toDate(), key: 'selection' }]);
    };
    const coordinatesData = async () => {
        const requestId = ++latestMapRequest.current;
        setMapLoadState('loading');
        setLoadingSpinner(true);
        setDisplayCoordinates([]);
        setCoordinates([]);
        try {
            const zones = selectedZones.length ? selectedZones.join(',') : '0';
            const res = await getcoordinatesData(selectedStaff,
                moment(sdate).tz('America/Los_Angeles').format('YYYY-MM-DD'),
                moment(edate).tz('America/Los_Angeles').format('YYYY-MM-DD'),
                debouncedSearch, zones);
            if (requestId !== latestMapRequest.current) return;
            if (res.code !== 200) throw new Error('Map request failed');
            const enriched = await addDurations(res.data?.data || []);
            if (requestId !== latestMapRequest.current) return;
            setDisplayCoordinates(enriched);
            setMapLoadState(enriched.length ? 'ready' : 'empty');
        } catch (err) {
            if (requestId !== latestMapRequest.current) return;
            setDisplayCoordinates([]);
            setCoordinates([]);
            setMapLoadState('error');
            console.error('Map request failed', err);
        } finally {
            if (requestId === latestMapRequest.current) setLoadingSpinner(false);
        }
    };
    useEffect(() => {
        coordinatesData();
        return () => { latestMapRequest.current += 1; };
    }, [selectedStaff, debouncedSearch, selectedZones, sdate, edate, refreshKey]);
    useEffect(() => { getstafflistwithlatlangfunc(); }, []);
    const handleButtonClick = () => setShow9(false);

    const [address, setAddress] = useState('');
    const [Newaddress, setNewAddress] = useState('');

    const handleActiveMarker = (marker) => {
        setActiveMarker(marker);
    };



    const getRandomColor = (key, colorMap) => {
        if (!colorMap[key]) {
            const hue = Math.floor(Math.random() * 360);
            colorMap[key] = `hsl(${hue}, 100%, 50%)`;
        }
        return colorMap[key];
    };


    useEffect(() => {
        if (!map || !window.google || !staffscoordinates.length) return;

        const colorMap = {};
        const markers = [];

        staffscoordinates.forEach((staff) => {
            if (staff.staff_view !== 1) return;

            const latLng = new window.google.maps.LatLng(parseFloat(staff.lat), parseFloat(staff.lang));
            const color = getRandomColor(staff.fullname, colorMap);

            const marker = new window.google.maps.Marker({
                position: latLng,
                map,
                icon: {
                    path: window.google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                    fillColor: color,
                    fillOpacity: 0.9,
                    scale: 10,
                    strokeColor: "#000",
                    strokeWeight: 1,
                },
                title: staff.fullname,
            });

            marker.addListener("click", () => {
                getAddress(staff.lat, staff.lang).then((addr) => {
                    setAddress(addr);
                    setStaffHoveredMarker(staff);
                });
            });

            markers.push(marker);
        });

        const cluster = new MarkerClusterer({ markers, map });

        return () => {
            cluster.clearMarkers();
        };
    }, [map, staffscoordinates]);

    const [usercrmid, setUsercrmid] = useState(0);

    const callChildFunction = (userid) => {
        setUsercrmid(userid);
    };

    const [bookingid, setBookingId] = useState(0);
    const [oldbookingid, setOldBookingId] = useState(0);

    const callBookingFunction = (booking_id) => {
        setBookingId(booking_id);
    };


    const [isSingleDayView, setisSingleDayView] = useState(true);

    const [show07, setShow07] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [spinnerloading, setSpinnerLoading] = useState(false);

    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);

    const mapRef = useRef(null);
    const inputRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const markerRef = useRef(null);
    const geocoderRef = useRef(null);



    const handleClose07 = () => {
        setShow07(false);
        setSelectedRow(null);
    };


    const columns = [
        {
            dataField: "order_date",
            text: "Appointment Date",
            sort: true,
            formatter: (cell, row) => (
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        callBookingFunction(row.order_id);
                    }}
                >
                    {cell}
                </a>
            ),
        },
        {
            dataField: "name",
            text: "Client Name",
            sort: true,
            formatter: (cell, row) => (
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        callChildFunction(row.client_id);
                    }}
                >
                    {cell}
                </a>
            ),
        },
        {
            dataField: "address",
            text: "Client Address",
            sort: true,
            formatter: (cell, row) => {
                const hasGPS = row.lat && row.lng && !isNaN(parseFloat(row.lat)) && !isNaN(parseFloat(row.lng));
                return (
                    <div
                        onMouseEnter={() => {
                            if (window.highlightBalloon) window.highlightBalloon(row.order_id);
                        }}
                        onMouseLeave={() => {
                            if (window.removeBalloonHighlight) window.removeBalloonHighlight(row.order_id);
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span>{row.address}, {row.city}, {row.zip}, {row.state}</span>

                            {/* {!hasGPS && (
                                <FaPencilAlt
                                    size={45}
                                    style={{ color: "orange", cursor: "pointer" }}
                                    title="Update GPS Coordinates"

                                />
                            )} */}
                        </div>

                        {!hasGPS && (
                            // <div style={{ color: "red", fontWeight: "bold" }} onClick={() => {
                            //     setSelectedRow(row);
                            //     setShow07(true);
                            // }}>
                            //     🔴 Missing GPS – Please update lat lng
                            // </div>
                            <a
                                href="#"
                                style={{ color: "red", fontWeight: "bold" }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedRow(row);
                                    setShow07(true);
                                }}
                            >
                                🔴 Missing GPS – Please update lat lng
                            </a>


                        )}
                    </div>
                );
            },
        },
        {
            dataField: "staff_names",
            text: "Technician(s) Assigned",
            formatter: (cell, row) => {
                const ids = row.staff_ids?.split(",") || [];
                const names = cell?.split(",") || [];
                return (
                    <>
                        {ids.map((id, index) => (
                            <a
                                key={id}
                                href={`/technician?id=${id.trim()}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: "6px" }}
                            >
                                {names[index] ? names[index].trim() : `Technician ${id.trim()}`}
                            </a>
                        ))}
                    </>
                );
            }
        },
        {
            dataField: "billed_hours",
            text: "Billed Hours"
        },
    ];


    if (true) {
        columns.push(
            {
                dataField: "staff_drive_km",
                text: "Staff Drive Distance (miles)",
                formatter: (cell, row) => {
                    if (!row.staff_drive_km) return "—";
                    const names = row.staff_names?.split(",") || [];

                    const distanceRows = Object.keys(row.staff_drive_km).map((id, index) => {
                        const km = row.staff_drive_km[id] ?? 0;
                        return (
                            <div key={id}>
                                <strong>{names[index]?.trim() || `Tech ${id}`}:</strong> {kmToMiles(km)} miles
                            </div>
                        );
                    });

                    const totalKm = Object.values(row.staff_drive_km).reduce((sum, v) => sum + (parseFloat(v) || 0), 0);

                    distanceRows.push(
                        <div key="total" style={{ fontWeight: "bold", marginTop: "4px" }}>
                            {/* TOTAL: {totalKm.toFixed(2)} km */}
                            TOTAL: {kmToMiles(totalKm)} miles
                        </div>
                    );

                    return <div>{distanceRows}</div>;
                }
            },
            {
                dataField: "staff_drive_minutes",
                text: "Staff Drive Time (mins)",
                formatter: (cell, row) => {
                    if (!row.staff_drive_minutes) return "—";
                    const names = row.staff_names?.split(",") || [];

                    const timeRows = Object.keys(row.staff_drive_minutes).map((id, index) => {
                        const mins = row.staff_drive_minutes[id] ?? 0;
                        return (
                            <div key={id}>
                                <strong>{names[index]?.trim() || `Tech ${id}`}:</strong> {mins} min
                            </div>
                        );
                    });

                    const totalMins = Object.values(row.staff_drive_minutes).reduce((sum, v) => sum + (parseFloat(v) || 0), 0);

                    timeRows.push(
                        <div key="total" style={{ fontWeight: "bold", marginTop: "4px" }}>
                            TOTAL: {totalMins} min
                        </div>
                    );

                    return <div>{timeRows}</div>;
                }
            }
        );
    }



    // const haversine = (coord1, coord2) => {
    //     const toRad = (deg) => deg * (Math.PI / 180);
    //     const R = 3958.8; // Radius of Earth in miles

    //     const dLat = toRad(coord2.lat - coord1.lat);
    //     const dLon = toRad(coord2.lng - coord1.lng);

    //     const a =
    //         Math.sin(dLat / 2) ** 2 +
    //         Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) * Math.sin(dLon / 2) ** 2;

    //     return 2 * R * Math.asin(Math.sqrt(a));
    // };


    // const calculateDriveDistances = (appointments) => {
    //     const updatedRows = [...appointments];

    //     for (let i = 0; i < updatedRows.length; i++) {
    //         const row = updatedRows[i];

    //         if (!row.lat || !row.lng || !row.order_date) {
    //             row.drive_distance = null;
    //             continue;
    //         }

    //         // Multiple techs
    //         if (row.staff_ids && row.staff_ids.includes(",")) {
    //             row.drive_distance = getLongestDistance(updatedRows, row);
    //             continue;
    //         }

    //         // Single tech
    //         const staffId = row.staff_ids?.trim();
    //         const sameTech = updatedRows
    //             .filter(r => r.staff_ids === staffId)
    //             .sort((a, b) => new Date(a.order_date) - new Date(b.order_date));

    //         const index = sameTech.findIndex(r => r.order_id === row.order_id);
    //         if (index === 0) {
    //             row.drive_distance = 0;
    //         } else {
    //             const prev = sameTech[index - 1];
    //             const dist = haversine(
    //                 { lat: parseFloat(prev.lat), lng: parseFloat(prev.lng) },
    //                 { lat: parseFloat(row.lat), lng: parseFloat(row.lng) }
    //             );
    //             row.drive_distance = dist.toFixed(2);
    //         }
    //     }

    //     return updatedRows;
    // };


    const haversine = (coord1, coord2) => {
        const toRad = (deg) => deg * (Math.PI / 180);
        const R = 3958.8; // Radius of Earth in miles

        const dLat = toRad(coord2.lat - coord1.lat);
        const dLon = toRad(coord2.lng - coord1.lng);

        const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) * Math.sin(dLon / 2) ** 2;

        return 2 * R * Math.asin(Math.sqrt(a));
    };

    const calculateDriveDistances = (appointments) => {
        const sortedRows = [...appointments].sort(
            (a, b) => new Date(a.order_date) - new Date(b.order_date)
        );

        for (let i = 0; i < sortedRows.length; i++) {
            const current = sortedRows[i];

            if (!current.lat || !current.lng || !current.order_date) {
                current.drive_distance = null;
                continue;
            }

            if (i === 0) {
                current.drive_distance = 0; // First booking, no previous
                continue;
            }

            const prev = sortedRows[i - 1];
            const dist = haversine(
                { lat: parseFloat(prev.lat), lng: parseFloat(prev.lng) },
                { lat: parseFloat(current.lat), lng: parseFloat(current.lng) }
            );
            current.drive_distance = dist.toFixed(2);
        }

        return sortedRows;
    };

    const getLongestDistance = (rows, currentRow) => {
        const currentCoords = {
            lat: parseFloat(currentRow.lat),
            lng: parseFloat(currentRow.lng),
        };
        const staffIds = currentRow.staff_ids?.split(",") || [];

        let totalDistance = 0;

        for (let staffId of staffIds) {
            const cleanId = staffId.trim();

            const techRows = rows
                .filter(r =>
                    r.staff_ids?.split(",").map(s => s.trim()).includes(cleanId)
                )
                .sort((a, b) => new Date(a.order_date) - new Date(b.order_date));

            const index = techRows.findIndex(r => r.order_id === currentRow.order_id);
            if (index > 0) {
                const prev = techRows[index - 1];
                const dist = haversine(
                    { lat: parseFloat(prev.lat), lng: parseFloat(prev.lng) },
                    currentCoords
                );
                totalDistance += dist;
            }
        }

        return totalDistance.toFixed(2);
    };

    // const getLongestDistance = (rows, currentRow) => {
    //     const currentCoords = { lat: parseFloat(currentRow.lat), lng: parseFloat(currentRow.lng) };
    //     const staffIds = currentRow.staff_ids?.split(",") || [];

    //     let maxDistance = 0;

    //     for (let staffId of staffIds) {
    //         const cleanId = staffId.trim();
    //         const techRows = rows
    //             .filter(r => r.staff_ids?.split(",").map(s => s.trim()).includes(cleanId))
    //             .sort((a, b) => new Date(a.order_date) - new Date(b.order_date));

    //         const index = techRows.findIndex(r => r.order_id === currentRow.order_id);
    //         if (index > 0) {
    //             const prev = techRows[index - 1];
    //             const dist = haversine({ lat: parseFloat(prev.lat), lng: parseFloat(prev.lng) }, currentCoords);
    //             if (dist > maxDistance) maxDistance = dist;
    //         }
    //     }

    //     return maxDistance.toFixed(2);
    // };

    useEffect(() => {
        if (isSingleDayView && displayCoordinates.length > 0) {
            const enriched = calculateDriveDistances(displayCoordinates);
            setCoordinates(displayCoordinates);
        } else {
            setCoordinates(displayCoordinates);
        }
    }, [displayCoordinates, isSingleDayView]);


    const technicianColorMap = useMemo(() => {
        const map = {};
        coordinates.forEach((mp) => {
            const key = isSingleDay
                ? (mp.staff_names?.split(",")[0].trim() || "Unknown")
                : moment(mp.order_date).format("YYYY-MM-DD");

            if (!map[key]) {
                const hue = Math.floor(Math.random() * 360);
                map[key] = `hsl(${hue}, 100%, 50%)`;
            }
        });
        return map;
    }, [coordinates, isSingleDay]);


    const getTechnicianColor = (techName, mapRef) => {
        if (!mapRef[techName]) {
            const hue = Math.floor(Math.random() * 360);
            mapRef[techName] = `hsl(${hue}, 100%, 50%)`;
        }
        return mapRef[techName];
    };

    function countInvalidLatLng(bookings) {
        return bookings.filter(b => !usableLocation(b)).length;
    }

    const updateAddressAndGPS = () => {
        setShow07(false);
        const formData = new FormData();
        formData.append("lat", lat);
        formData.append("lng", lng);
        formData.append("order_id", selectedRow.order_id);

        updatelatlonginbooking(formData).then((response) => {
            if (response.code === 200) {
                const apiResponse = response.data;
                setRefreshKey(key => key + 1);
            }
        }).catch((err) => {
            console.log(err);
        });

    }

    useEffect(() => {
        if (show07) {
            loadGoogleMapsScript(() => {
                initMap();
            });
        }
    }, [show07]);


    const loadGoogleMapsScript = (callback) => {
        if (window.google && window.google.maps && window.google.maps.places) {
            callback();
        } else {
            const existingScript = document.getElementById("googleMaps");
            if (!existingScript) {
                const script = document.createElement("script");
                script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA9PRZ4LU9yTqlpV6d7-GH11B70BZKVJOU&libraries=places`;
                script.id = "googleMaps";
                script.async = true;
                script.defer = true;
                script.onload = () => {
                    // wait for window.google.maps.places to be available
                    const checkPlaces = setInterval(() => {
                        if (window.google?.maps?.places) {
                            clearInterval(checkPlaces);
                            callback();
                        }
                    }, 100);
                };
                document.body.appendChild(script);
            } else {
                existingScript.onload = callback;
            }
        }
    };


    const initMap = () => {
        const map = new window.google.maps.Map(mapRef.current, {
            center: center,
            zoom: 13,
        });
        mapInstanceRef.current = map;

        mapInstanceRef.current = map;
        geocoderRef.current = new window.google.maps.Geocoder();

        const input = inputRef.current;
        const searchBox = new window.google.maps.places.SearchBox(input);

        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

        map.addListener("bounds_changed", () => {
            searchBox.setBounds(map.getBounds());
        });

        searchBox.addListener("places_changed", () => {
            const places = searchBox.getPlaces();
            if (!places.length) return;

            const place = places[0];
            if (!place.geometry || !place.geometry.location) return;

            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();

            if (markerRef.current) markerRef.current.setMap(null);

            markerRef.current = new window.google.maps.Marker({
                map,
                position: place.geometry.location,
                draggable: true,
            });

            //When marker is dragged, update lat/lng
            markerRef.current.addListener('dragend', function (event) {
                const newLat = event.latLng.lat();
                const newLng = event.latLng.lng();
                setLat(newLat);
                setLng(newLng);
                reverseGeocode(newLat, newLng);
            });

            setLat(lat);
            setLng(lng);
            map.panTo(place.geometry.location);
            map.setZoom(15);
        });
    };

    const reverseGeocode = (lat, lng) => {
        if (!geocoderRef.current) return;

        geocoderRef.current.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === "OK" && results[0]) {
                setNewAddress(results[0].formatted_address);
            }
        });
    };


    setTimeout(() => {
        const pacContainer = document.querySelector('.pac-container');
        const modalBody = document.querySelector('.custom-map-modal .modal-body');

        if (pacContainer && modalBody) {
            modalBody.appendChild(pacContainer);
        }
    }, 500);

    function normalizeStaffIDs(ids) {
        return ids.split(",").map(id => id.trim()).sort().join(",");
    }

    // Parse coordinate safely
    const parseCoordinate = (value) => {
        const num = parseFloat(value);
        return isNaN(num) ? null : num;
    };

    const [ratio, setRatio] = useState(null);
    const [totalBilledHours, setTotalBilledHours] = useState(0);
    const [totalDriveTime, setTotalDriveTime] = useState(0);

    async function addDurationsold(bookings) {
        const sortedBookings = [...bookings].sort((a, b) => {
            const aKey = normalizeStaffIDs(a.staff_ids || "");
            const bKey = normalizeStaffIDs(b.staff_ids || "");
            if (aKey === bKey) {
                return new Date(a.order_date) - new Date(b.order_date);
            }
            return aKey.localeCompare(bKey);
        });

        const prevMap = new Map(); // For duration per staff
        const updated = [];

        let lastBookingForDistance = null; // Only for drive_distance
        let billedSum = 0;

        for (let booking of sortedBookings) {
            const lat2 = parseCoordinate(booking.lat);
            const lng2 = parseCoordinate(booking.lng);
            const billed = parseFloat(booking.billed_hours || 0);

            const rawStaff = Array.isArray(booking.staff_ids) ? booking.staff_ids : [booking.staff_ids];
            const staffList = rawStaff.flatMap(id =>
                id.toString().split(',').map(s => s.trim()).filter(Boolean)
            );
            let totalDuration = 0;
            let gpsUsed = false;

            // 🕐 Duration: per staff
            for (let staffId of staffList) {
                const normalizedStaff = normalizeStaffIDs(staffId);
                const prev = prevMap.get(normalizedStaff);

                if (prev) {
                    const lat1 = parseCoordinate(prev.lat);
                    const lng1 = parseCoordinate(prev.lng);

                    if (lat1 !== null && lng1 !== null && lat2 !== null && lng2 !== null) {
                        const from = { latitude: lat1, longitude: lng1 };
                        const to = { latitude: lat2, longitude: lng2 };

                        try {
                            const result = await haversineNew(from, to);
                            totalDuration += result.duration || 0;
                            gpsUsed = true;
                        } catch (err) {
                            const timeGap = (new Date(booking.order_date) - new Date(prev.order_date)) / (1000 * 60);
                            if (timeGap > 0) {
                                totalDuration += Math.round(timeGap);
                            }
                        }
                    } else {
                        const timeGap = (new Date(booking.order_date) - new Date(prev.order_date)) / (1000 * 60);
                        if (timeGap > 0) {
                            totalDuration += Math.round(timeGap);
                        }
                    }
                }

                prevMap.set(normalizedStaff, booking); // update per staff
            }

            // 🚗 Drive Distance: per booking only
            let totalDistance = 0;
            try {
                if (
                    lastBookingForDistance &&
                    lat2 !== null && lng2 !== null &&
                    parseCoordinate(lastBookingForDistance.lat) !== null &&
                    parseCoordinate(lastBookingForDistance.lng) !== null
                ) {
                    const from = {
                        latitude: parseCoordinate(lastBookingForDistance.lat),
                        longitude: parseCoordinate(lastBookingForDistance.lng),
                    };
                    const to = { latitude: lat2, longitude: lng2 };

                    const result = await haversineNew(from, to);
                    totalDistance = (result.distance || 0) / 1609.34; // meters to miles
                    gpsUsed = true;
                }
            } catch (err) {
                totalDistance = 0;
            }
            booking.duration = Math.round(totalDuration);
            booking.drive_distance = Math.round(totalDistance);
            booking.gps_based = gpsUsed;
            billedSum += billed;

            updated.push(booking);
            lastBookingForDistance = booking; // update distance tracker
        }

        const totalDriveTime = updated.reduce((sum, booking) => {
            return sum + (typeof booking.duration === "number" && !isNaN(booking.duration) ? booking.duration : 0);
        }, 0);
        const calculatedRatio = billedSum > 0 ? billedSum / totalDriveTime : 0;
        setTotalDriveTime(totalDriveTime);
        setRatio(calculatedRatio);
        setTotalBilledHours(billedSum);
        return updated;
    }




    async function addDurations(bookings) {
        // ---------- helpers (scoped to this function) ----------
        const toNum = (v) => {
            const n = Number(v);
            return Number.isFinite(n) ? n : null;
        };

        const parseStaffIds = (field) =>
            String(field ?? "")
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean);

        // Prefer duration (mins) if > 0, else billed_hours (assumed mins), else 0
        const getCleaningMinutes = (b) => {
            const d = toNum(b.duration);
            if (d && d > 0) return d;
            const bh = toNum(b.billed_hours);
            return bh && bh > 0 ? bh : 0;
        };

        const coordKey = ({ lat, lng }) => `${Number(lat).toFixed(4)},${Number(lng).toFixed(4)}`;

        // Memoized Distance Matrix wrapper
        const distanceCache = new Map();
        const getDrive = async (prev, curr) => {
            const key = `${coordKey(prev)}|${coordKey(curr)}`;
            if (distanceCache.has(key)) return distanceCache.get(key);

            const res = await haversineNew(
                { latitude: prev.lat, longitude: prev.lng },
                { latitude: curr.lat, longitude: curr.lng }
            ).catch(() => ({ duration: 0, distance: 0 }));

            distanceCache.set(key, res);
            return res;
        };

        // ---------- parse all bookings (keep even if GPS missing) ----------
        const parsedAll = bookings.map((b) => {
            const lat = (b?.lat == null || b.lat === "null") ? null : toNum(b.lat);
            const lng = (b?.lng == null || b.lng === "null") ? null : toNum(b.lng);
            const has_gps = lat != null && lng != null;
            const orderDate = b?.order_date ? new Date(b.order_date) : null;
            const dateStr = b?.order_date ? b.order_date.split(" ")[0] : null;

            return {
                ...b,
                lat,
                lng,
                has_gps,
                orderDate,
                dateStr,
                staffIds: parseStaffIds(b?.staff_ids),
            };
        });

        // Build a map we will augment for ALL bookings (gps or not)
        const bookingMap = new Map();
        parsedAll.forEach((b) => {
            bookingMap.set(b.order_id, {
                ...b,
                cleaning_minutes: getCleaningMinutes(b),
                staff_drive_minutes: {}, // { [staffId]: minutes }
                staff_drive_km: {},      // { [staffId]: km }
                total_drive_minutes: 0,
                total_drive_km: 0,
            });
        });

        // ---------- compute per-staff drive per day (GPS-valid only) ----------
        const gpsValid = parsedAll
            .filter((b) => b.has_gps && b.orderDate instanceof Date && !isNaN(b.orderDate))
            .sort((a, b) => a.orderDate - b.orderDate);

        // Group GPS-valid by date
        const byDate = new Map();
        gpsValid.forEach((b) => {
            if (!byDate.has(b.dateStr)) byDate.set(b.dateStr, []);
            byDate.get(b.dateStr).push(b);
        });

        // Staff route chaining per day (only GPS-valid)
        for (const [, dayBookings] of byDate.entries()) {
            // staff -> their bookings (chronological)
            const staffToBookings = new Map();
            dayBookings.forEach((b) => {
                b.staffIds.forEach((sid) => {
                    if (!staffToBookings.has(sid)) staffToBookings.set(sid, []);
                    staffToBookings.get(sid).push(b);
                });
            });

            for (const [sid, list] of staffToBookings.entries()) {
                list.sort((a, b) => a.orderDate - b.orderDate);

                let prevLoc = null;
                for (let i = 0; i < list.length; i++) {
                    const curr = list[i];
                    const currLoc = { lat: curr.lat, lng: curr.lng };

                    let driveMin = 0;
                    let driveKm = 0;

                    if (prevLoc) {
                        const { duration, distance } = await getDrive(prevLoc, currLoc);
                        driveMin = Math.round(duration || 0);
                        driveKm = Number(distance || 0);
                    }
                    // First job for this staff that day: driveMin=0

                    const aug = bookingMap.get(curr.order_id);
                    if (aug) {
                        aug.staff_drive_minutes[sid] = (aug.staff_drive_minutes[sid] || 0) + driveMin;
                        aug.staff_drive_km[sid] = (aug.staff_drive_km[sid] || 0) + driveKm;
                        aug.total_drive_minutes += driveMin;
                        aug.total_drive_km += driveKm;
                    }

                    prevLoc = currLoc;
                }
            }
        }

        // ---------- build final array in chronological order (show ALL bookings) ----------
        const augmentedBookings = [...bookingMap.values()]
            .sort((a, b) => {
                const da = a.orderDate instanceof Date && !isNaN(a.orderDate) ? a.orderDate : new Date(0);
                const db = b.orderDate instanceof Date && !isNaN(b.orderDate) ? b.orderDate : new Date(0);
                return da - db;
            });

        // ---------- totals: EXCLUDE no-GPS from calculations ----------
        let totalDriveTime = 0;
        let totalBilledHours = 0;
        augmentedBookings.forEach((b) => {
            if (b.has_gps) {
                totalDriveTime += Number(b.total_drive_minutes || 0);
            }
            // billed_hours can be included in ratio as you prefer; keeping behavior same as earlier,
            // but if you want to exclude no-GPS bookings from billed hours too, add `&& b.has_gps` here.
            totalBilledHours += Number(b.billed_hours || 0);
        });

        // Update external state (as in your original code)
        setTotalDriveTime(totalDriveTime);
        setTotalBilledHours(totalBilledHours);
        setRatio(((totalBilledHours) + totalDriveTime) / ((totalBilledHours))); // avoid divide by 0

        return augmentedBookings;
    }


    async function haversineNew(from, to) {
        return new Promise((resolve, reject) => {
            const matrix = new window.google.maps.DistanceMatrixService();

            matrix.getDistanceMatrix(
                {
                    origins: [{ lat: from.latitude, lng: from.longitude }],
                    destinations: [{ lat: to.latitude, lng: to.longitude }],
                    travelMode: window.google.maps.TravelMode.DRIVING,
                },
                (response, status) => {
                    if (status === 'OK') {
                        try {
                            const distance = response.rows[0].elements[0].distance.value; // distance in meters
                            const duration = response.rows[0].elements[0].duration.value;

                            const km = distance * 0.001;
                            const durationInMinutes = duration / 60;

                            resolve({ duration: durationInMinutes, distance: km });
                        } catch (error) {
                            reject(0);
                        }
                    } else {
                        reject({ duration: 0, distance: 0 });
                    }
                }
            );
        });
    }

    // Haversine Formula to calculate distance between two coordinates
    function haversineDistance(lat1, lon1, lat2, lon2) {
        // Ensure all inputs are valid numbers
        if ([lat1, lon1, lat2, lon2].some(isNaN)) return 0;

        const R = 3958.8; // Earth radius in miles
        const toRad = deg => (deg * Math.PI) / 180;

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);


        const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;


        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c;
    }

    const toggleZone = (id) => {
        if (selectedZones.includes(id)) {
            setSelectedZones(selectedZones.filter((z) => z !== id));
        } else {
            setSelectedZones([...selectedZones, id]);
        }
    };

    const isAllSelected = selectedZones.length === 0;

    // useEffect(() => {
    //     let billedSum = 0;
    //     let driveTimeSum = 0;
    //     if (totalDriveTime > 0) {
    //         coordinates.forEach((order) => {
    //             const billed = parseFloat(order.billed_hours || 0);
    //             const lat = parseFloat(order.lat);
    //             const lng = parseFloat(order.lng);

    //             if (isNaN(lat) || isNaN(lng)) {
    //                 console.warn('Skipping invalid coordinates:', order.lat, order.lng);
    //                 return;
    //             }

    //             const distance = haversineDistance(center.lat, center.lng, lat, lng);
    //             const driveTime = distance / 30;

    //             billedSum += billed;
    //             driveTimeSum += driveTime;
    //         });
    //         const calculatedRatio = billedSum > 0 ? billedSum / totalDriveTime : 0;
    //         setTotalBilledHours(billedSum);
    //         setRatio(calculatedRatio);
    //     }
    // }, [coordinates, totalDriveTime]);



    return (
        <>

            <Modal show={show07} onHide={handleClose07} centered size="xl" className='custom-map-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Update Address & GPS</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ position: "relative" }}>
                    <p style={{ color: "black", fontWeight: "600" }}>
                        {`Your current booking address is  ${selectedRow?.address},${selectedRow?.city},${selectedRow?.state},${selectedRow?.zip} `}
                    </p>
                    <div className="row">

                        {/* <div className="col-2">  */}
                        {/* <Form.Group className="mb-3" controlId="formAddress">
                                <Form.Label>Address</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Address"
                                    value={selectedRow?.address || ""}
                                    onChange={(e) => setSelectedRow({ ...selectedRow, address: e.target.value })}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formCity">
                                <Form.Label>City</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter City"
                                    value={selectedRow?.city || ""}
                                    onChange={(e) => setSelectedRow({ ...selectedRow, city: e.target.value })}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formZip">
                                <Form.Label>Zip Code</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Zip"
                                    value={selectedRow?.zip || ""}
                                    onChange={(e) => setSelectedRow({ ...selectedRow, zip: e.target.value })}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formState">
                                <Form.Label>State</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter State"
                                    value={selectedRow?.state || ""}
                                    onChange={(e) => setSelectedRow({ ...selectedRow, state: e.target.value })}
                                />
                            </Form.Group> */}
                        {/* <Form.Group className="mb-3" controlId="formState">
                                <Form.Label>State</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter State"
                                    value={selectedRow?.state || ""}
                                    onChange={(e) => setSelectedRow({ ...selectedRow, state: e.target.value })}
                                />
                            </Form.Group> */}
                        {/* </div> */}
                        <div className='col-12'>
                            <input
                                ref={inputRef}
                                id="pac-input"
                                className="form-control"
                                type="text"
                                placeholder="Search Address"
                                value={Newaddress}
                                onChange={(e) => setNewAddress(e.target.value)}
                                style={{
                                    position: "absolute",
                                    top: "0.7rem",
                                    zIndex: "1000",
                                    right: "0rem",
                                    width: "50%",
                                }}
                                autoComplete="on"
                            />
                            <div
                                ref={mapRef}
                                id="map"
                                style={{ height: "70vh", width: "100%" }}
                            ></div>
                        </div>
                    </div>

                    <style>
                        {`
                            .custom-map-modal .modal-dialog{
                                min-width: 1000px !important;
                                min-height: 900px !important;
                                max-height: 900px !important;
                                max-width: 1000px !important;
                            }
                                .form-control.pac-target-input{
                                    top: 0.7rem !important;
                                }

                            // .pac-container.pac-logo{
                            //     z-index: 1000000 !important;
                            //     top: 50rem !important;
                            //     left: 50rem !important;
                            // }

                            .pac-container {
        z-index: 99999999 !important; /* Above modal (Bootstrap modal z-index is 1050) */
        position: absolute !important;
        left: 54% !important;
    top: 8% !important;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
    }

    /* Optional: narrow it to match input width */
    #pac-input + .pac-container {
        width: 30% !important;
        right: 0.5rem !important;
        top: 3rem !important; /* Adjust this according to input position */
    }
                    `}
                    </style>

                </Modal.Body>

                <Modal.Footer className='justify-content-between'>
                    <p style={{ color: "red", fontWeight: "600" }}>
                        {`Your current lat lng is ${lat},${lng}`}
                    </p>
                    <div>
                        {
                            lat === null ? (
                                <button className="Active-bttn btn" disabled>
                                    update lat lang
                                </button>) : (
                                <button className="Active-bttn btn" onClick={updateAddressAndGPS}>
                                    Update lat lang
                                </button>
                            )
                        }
                        <button className="Cancel-bttn btn" onClick={handleClose07}>Cancel</button>
                    </div>
                </Modal.Footer>
            </Modal>


            <Modal show={show9} onHide={handleClose9} centered className="modal-center">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Filter data
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="date-picker">
                                <Form.Group
                                    className="booking-custom-lable"
                                    controlId="formBasicEmail"
                                >
                                    <div className="row">
                                        <div className="col-md-12">
                                            <DateRangePicker
                                                onChange={(item) => {
                                                    setSdate(item.selection.startDate);
                                                    setEdate(item.selection.endDate);
                                                    setDates([item.selection]);
                                                    setDatePreset("Custom Range");
                                                    setDatesColors({})
                                                }}
                                                showSelectionPreview={true}
                                                moveRangeOnFirstSelection={false}
                                                // months={2}
                                                ranges={dates}
                                                direction="horizontal"
                                            />
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <div className="dashboard-container d-flex">
                <div className="sidebar-container">
                    <Sidebar />
                </div>
                <div className="main-container">
                    <div className="main-page-body-content">
                        {/* <div className="main-page-body-content-header">
                            <Header />
                        </div> */}
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fulid">
                                    <div className="">
                                        <div className="table-card ">
                                            <div className="card-body table-card-body">
                                                <div className="table-card-header d-flex justify-content-between">
                                                    <h5 className="card-title">MapView</h5>
                                                </div>
                                                <div className="mb-3 d-flex flex-wrap gap-2">
                                                    {['Today', 'Tomorrow', 'This Week', 'Next Week'].map(preset =>
                                                        <Button key={preset} variant={datePreset === preset ? 'primary' : 'outline-secondary'}
                                                            onClick={() => applyDatePreset(preset)}>{preset}</Button>)}
                                                    <Button variant="outline-secondary" onClick={() => { setDatePreset('Custom Range'); handleShow9(); }}>Custom Range</Button>
                                                    <Button variant="outline-secondary" onClick={() => setMoreFiltersOpen(open => !open)}>More Filters</Button>
                                                </div>
                                                <div className="mb-3">
                                                    {moment(sdate).format('MMM D')}–{moment(edate).format('MMM D, YYYY')}
                                                    {' · '}{String(selectedStaff) === '0' ? 'All Technicians' : (staffList?.find(staff => String(staff.value) === String(selectedStaff))?.label || 'Selected Technician')}
                                                    {' · '}{displayCoordinates.length} appointments
                                                    {' · '}{technicianCount} technicians
                                                    {' · '}{missingAppointments.length} locations unavailable
                                                </div>
                                                {mapLoadState === 'loading' && <div role="status">Loading appointments...</div>}
                                                {mapLoadState === 'empty' && <div>No appointments match these filters.</div>}
                                                {mapLoadState === 'error' && <div role="alert">Appointments could not be loaded. Please try again.
                                                    <Button size="sm" onClick={() => setRefreshKey(key => key + 1)}>Retry</Button>
                                                </div>}
                                                {missingAppointments.length > 0 && <details className="mb-3">
                                                    <summary>{missingAppointments.length} appointments could not be shown on the map. View Missing Appointments</summary>
                                                    <ul>{missingAppointments.map(booking => <li key={booking.order_id}>
                                                        {moment(booking.order_date).format('MMM D, YYYY')} — {booking.name} — {booking.staff_names || booking.staff_ids} — Order {booking.order_id}
                                                    </li>)}</ul>
                                                </details>}
                                                <div className="row">
                                                    <div className='col-lg-3' style={{ display: moreFiltersOpen ? 'block' : 'none' }}>
                                                        <div className="form-group mb-4">
                                                            {/* <Form.Label htmlFor="inputPassword5">Password</Form.Label> */}
                                                            {/* <Form.Select aria-label="Default select example" onChange={
                                                                (e) => {
                                                                    setchangesstaffzone(e.target.value);
                                                                }
                                                            }>
                                                                <option value="0">All Zone</option>
                                                                {bookingzonelist && bookingzonelist.map((zone) => (
                                                                    <option value={zone.id} >{zone.zone_name}</option>
                                                                ))}

                                                            </Form.Select> */}
                                                            <Dropdown style={{ width: "100%" }}>
                                                                <Dropdown.Toggle variant="" id="zone-select" style={{ width: "100%", border: "1px solid #ccc", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                    {isAllSelected ? "All Zones" : `${selectedZones.length} Selected`}
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu style={{ padding: "10px", width: "100%" }}>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        label="All Zones"
                                                                        checked={isAllSelected}
                                                                        onChange={() => setSelectedZones([])}
                                                                    />

                                                                    {bookingzonelist &&
                                                                        bookingzonelist.map((zone) => (
                                                                            <Form.Check
                                                                                key={zone.id}
                                                                                type="checkbox"
                                                                                label={zone.zone_name}
                                                                                checked={selectedZones.includes(zone.id)}
                                                                                onChange={() => toggleZone(zone.id)}
                                                                            />
                                                                        ))}
                                                                </Dropdown.Menu>
                                                            </Dropdown>

                                                        </div>
                                                    </div>
                                                    <div className='col-lg-3'>
                                                        <div className="form-group mb-4">
                                                            {/* <Form.Label htmlFor="inputPassword5">Password</Form.Label> */}
                                                            <Form.Select aria-label="Default select example" onChange={
                                                                (e) => {
                                                                    setSelectedStaff(e.target.value);
                                                                }
                                                            }>
                                                                <option value="0">All Technicians</option>
                                                                {
                                                                    staffList && staffList.map((staff) => {
                                                                        return (
                                                                            <option value={staff.value}>{staff.label}</option>
                                                                        )
                                                                    }
                                                                    )
                                                                }
                                                            </Form.Select>
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-3'>
                                                        <div className="date-picker d-flex align-items-center justify-content-between">
                                                            <button className="resize_btn btn" onClick={handleShow9}><div className="btn-text">Custom Range</div></button>
                                                            <div className="form-check form-switch">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    role="switch"
                                                                    id="flexSwitchCheckDefault"
                                                                    checked={isOn}
                                                                    onChange={() => setIsOn(!isOn)}
                                                                />
                                                                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                                                                    {isOn ? 'Employee Data' : 'No Employee Data'}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className='col-lg-3'>
                                                        <div className="form-group mb-4"> 
                                                            <Form.Select aria-label="Default select example" onChange={
                                                                (e) => {
                                                                    setGroupBy(e.target.value);
                                                                }
                                                            }>
                                                                <option value="date">Filter Data</option>
                                                                <option value="date">Day</option>
                                                                <option value="technician">Technician</option>
                                                            </Form.Select>
                                                        </div>
                                                    </div> */}
                                                </div>
                                                <div className="table-card-body-inner">
                                                    <div className=''>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='map-box'>


                                                                    {isLoaded ? (
                                                                        <>
                                                                            {
                                                                                coordinates.length > 0 ? (
                                                                                    <GoogleMap
                                                                                        key={groupBy}
                                                                                        onLoad={handleOnLoad}
                                                                                        onClick={() => setActiveMarker(null)}
                                                                                        mapContainerStyle={{ width: "100%", height: "100%" }}
                                                                                        defaultCenter={center}
                                                                                        defaultZoom={12}
                                                                                    >
                                                                                        {coordinates.filter(usableLocation).map((mp, idx) => {
                                                                                            const key = isSingleDay
                                                                                                ? (mp.staff_names?.split(",")[0].trim() || "Unknown")
                                                                                                : moment(mp.order_date).format("YYYY-MM-DD");

                                                                                            const color = technicianColorMap[key];

                                                                                            return (
                                                                                                <Marker
                                                                                                    key={`${mp.order_id || idx}-${mp.lat}-${mp.lng}`}
                                                                                                    position={{ lat: parseFloat(mp.lat), lng: parseFloat(mp.lng) }}
                                                                                                    icon={{
                                                                                                        path: window.google.maps.SymbolPath.CIRCLE,
                                                                                                        fillOpacity: 0.9,
                                                                                                        scale: 10,
                                                                                                        strokeColor: "#000",
                                                                                                        strokeWeight: 1,
                                                                                                    }}
                                                                                                    onClick={() => handleActiveMarker(mp)}
                                                                                                />
                                                                                            );
                                                                                        })}

                                                                                        {/* ---- RENDER ALL ZONES FROM KML ---- */}
                                                                                        {Object.entries(GREEN_FROG_ZONES).map(([name, paths]) => (
                                                                                            <Polygon key={name} paths={paths} options={zoneStyleByName(name)} />
                                                                                        ))}

                                                                                        {/* Optional: keep your five explicit polygons (they now reference the same data) */}
                                                                                        {/* 
                                                                                            <Polygon paths={sanDiegoCoords} options={zoneStyleByName("San Diego")} />
                                                                                            <Polygon paths={laMesaCoords} options={zoneStyleByName("La Mesa")} />
                                                                                            <Polygon paths={powayCoords} options={zoneStyleByName("Poway")} />
                                                                                            <Polygon paths={carlsbadCoords} options={zoneStyleByName("Carlsbad")} />
                                                                                            <Polygon paths={orangeCountyCoords} options={zoneStyleByName("Orange County")} />
                                                                                        */}

                                                                                        {/* ---- Staff avatars ---- */}
                                                                                        {!isOn || (staffscoordinates &&
                                                                                            staffscoordinates.map((mp, idx) =>
                                                                                                mp.staff_view === 1 ? (
                                                                                                    <OverlayView
                                                                                                        key={`staff-${mp.id || idx}`}
                                                                                                        position={{ lat: parseFloat(mp.lat), lng: parseFloat(mp.lang) /* NOTE: source uses 'lang' */ }}
                                                                                                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                                                                                    >
                                                                                                        <div
                                                                                                            onClick={() => handleStaffMarker(mp)}
                                                                                                            style={{
                                                                                                                width: 40,
                                                                                                                height: 40,
                                                                                                                borderRadius: "50%",
                                                                                                                overflow: "hidden",
                                                                                                                border: "2px solid #fff",
                                                                                                                boxShadow: "0 0 4px rgba(0,0,0,0.5)",
                                                                                                                cursor: "pointer",
                                                                                                            }}
                                                                                                        >
                                                                                                            <img
                                                                                                                src={mp.image !== "" ? SITE_URL + "uploads/photo/" + mp.image : "/favicon.ico"}
                                                                                                                alt="staff"
                                                                                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </OverlayView>
                                                                                                ) : null
                                                                                            ))}

                                                                                        {/* ---- Booking info window ---- */}
                                                                                        {activeMarker && (
                                                                                            <InfoWindow
                                                                                                position={{
                                                                                                    lat: parseFloat(activeMarker.lat),
                                                                                                    lng: parseFloat(activeMarker.lng),
                                                                                                }}
                                                                                                onCloseClick={() => setActiveMarker(null)}
                                                                                            >
                                                                                                <div className="info-window-content custom-info-window">
                                                                                                    <p className="info-window-title">
                                                                                                        <a
                                                                                                            href="#"
                                                                                                            onClick={(e) => {
                                                                                                                e.preventDefault();
                                                                                                                callBookingFunction(activeMarker.order_id);
                                                                                                            }}
                                                                                                        >
                                                                                                            {activeMarker.name}
                                                                                                        </a>
                                                                                                    </p>
                                                                                                    <p className="m-0">
                                                                                                        <strong>Technician:</strong>&nbsp;
                                                                                                        {activeMarker.staff_ids?.split(",").map((id, index) => {
                                                                                                            const names = activeMarker.staff_names?.split(",") || [];
                                                                                                            const techName = names[index]?.trim() || `Technician ${id.trim()}`;
                                                                                                            return (
                                                                                                                <a
                                                                                                                    key={id}
                                                                                                                    href={`/technician?id=${id.trim()}`}
                                                                                                                    target="_blank"
                                                                                                                    rel="noopener noreferrer"
                                                                                                                    style={{ marginRight: "6px" }}
                                                                                                                >
                                                                                                                    {techName}
                                                                                                                </a>
                                                                                                            );
                                                                                                        })}
                                                                                                    </p>
                                                                                                    <p className="m-0"><strong>Lat:</strong> {activeMarker.lat}</p>
                                                                                                    <p className="m-0"><strong>Lng:</strong> {activeMarker.lng}</p>
                                                                                                    <p className="m-0">
                                                                                                        <strong>Address:</strong><br />
                                                                                                        {activeMarker.address},<br />
                                                                                                        {activeMarker.city}, {activeMarker.zip}, {activeMarker.state}
                                                                                                    </p>
                                                                                                </div>
                                                                                            </InfoWindow>
                                                                                        )}

                                                                                        {/* ---- Staff hover info ---- */}
                                                                                        {staffhoveredMarker && (
                                                                                            <InfoWindow
                                                                                                position={{
                                                                                                    lat: parseFloat(staffhoveredMarker.lat),
                                                                                                    lng: parseFloat(staffhoveredMarker.lang), // NOTE: source uses 'lang'
                                                                                                }}
                                                                                                onCloseClick={() => setStaffHoveredMarker(null)}
                                                                                            >
                                                                                                <div
                                                                                                    className="info-window-content custom-info-window"
                                                                                                    style={{ maxWidth: 320, minWidth: 251 }}
                                                                                                >
                                                                                                    <p className="info-window-title">
                                                                                                        {staffhoveredMarker.fullname}
                                                                                                    </p>
                                                                                                    <p className="info-window-description">
                                                                                                        Latitude: {staffhoveredMarker.lat}<br />
                                                                                                        Longitude: {staffhoveredMarker.lang}<br />
                                                                                                        Address: {address}
                                                                                                    </p>
                                                                                                </div>
                                                                                            </InfoWindow>
                                                                                        )}
                                                                                    </GoogleMap>

                                                                                ) : (

                                                                                    <GoogleMap
                                                                                        mapContainerStyle={{ width: "100%", height: "100%" }}
                                                                                        center={center}
                                                                                        zoom={10}
                                                                                    >

                                                                                    </GoogleMap>
                                                                                )
                                                                            }
                                                                        </>
                                                                    ) : (
                                                                        <>Loading...</>
                                                                    )}
                                                                </div>

                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className="animated fadeIn">
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <div className="card">
                                                                                <div>
                                                                                    {
                                                                                        `${countInvalidLatLng(coordinates)} users dont have lat lang data`
                                                                                    }
                                                                                    <br />
                                                                                    {
                                                                                        true && (
                                                                                            <>
                                                                                                <h6>Billed Hours to Driving Time Ratio</h6>
                                                                                                <table class="summary-table">
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>Total Billed Hours</th>
                                                                                                            <th>Total Driving Time</th>
                                                                                                            <th>Ratio</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        <tr>
                                                                                                            <td>{totalBilledHours.toFixed(2)} minutes</td>
                                                                                                            <td>{totalDriveTime.toFixed(2)} minutes</td>
                                                                                                            <td>{ratio ? ratio.toFixed(4) : 'Calculating...'}</td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                                <style>
                                                                                                    {`
                                                                                                        <style>
                                                                                                        .summary-table {
                                                                                                            font-family: arial, sans-serif;
                                                                                                            border-collapse: collapse;
                                                                                                            width: 100%;
                                                                                                        }

                                                                                                        .summary-table td,
                                                                                                        .summary-table th {
                                                                                                            border: 1px solid #dddddd;
                                                                                                            text-align: left;
                                                                                                            padding: 8px;
                                                                                                        }

                                                                                                        .summary-table tr:nth-child(even) {
                                                                                                            background-color: #dddddd;
                                                                                                        }
                                                                                                        </style>
                                                                                                        `}
                                                                                                </style>
                                                                                            </>
                                                                                        )
                                                                                    }
                                                                                    {
                                                                                        !isSingleDayView && (
                                                                                            <>
                                                                                                <h6 className='mb-0' style={{ fontWeight: "500" }}>Colors</h6>
                                                                                                <div className='d-flex flex-wrap'>
                                                                                                    {Object.keys(datescolors).map((key) => (
                                                                                                        <>
                                                                                                            <div className='d-flex align-items-center gap-2'>
                                                                                                                <div key={key} style={{ fontWeight: "500" }}>
                                                                                                                    {key}
                                                                                                                </div>
                                                                                                                <div className='d-flex align-items-center'>
                                                                                                                    <span className={`badge rounded-pill`} style={{ backgroundColor: datescolors[key], color: 'white', minHeight: "20px", height: "20px", minWidth: "40px", fontSize: "1px" }}>.</span>
                                                                                                                    <span>,&nbsp;</span>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </>
                                                                                                    ))}
                                                                                                </div>
                                                                                            </>
                                                                                        )
                                                                                    }

                                                                                </div>
                                                                                {moreFiltersOpen && <div className="card-header d-flex table-card-header">
                                                                                    <Form.Group>
                                                                                        <div className="d-flex">
                                                                                            <Form.Control
                                                                                                placeholder='search'
                                                                                                value={searchValue}
                                                                                                onChange={handleSearch.bind(this)}
                                                                                                type="text"
                                                                                            />
                                                                                            <Button size="sm" onClick={() => setSearchValue("")}>Clear</Button>
                                                                                        </div>
                                                                                    </Form.Group>
                                                                                </div>}
                                                                                <div className="card-body">
                                                                                    <BootstrapTable
                                                                                        bootstrap4
                                                                                        keyField="id"
                                                                                        data={coordinates}
                                                                                        columns={columns}
                                                                                        pagination={pagination}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            usercrmid != 0 ? (
                                <ChildComponent id={usercrmid} onCloseidChange={(editid) => setUsercrmid(editid)} />
                            ) : (
                                <></>
                            )
                        }
                        {
                            bookingid != 0 ? (
                                <BookingComponent order_id={bookingid} onCloseidChangebooking={(editbookingid) => setBookingId(editbookingid)} onCloseidChangeoldbookingid={(oldbookingid) => setOldBookingId(oldbookingid)} />
                            ) : (
                                <></>
                            )

                        }
                    </div>
                </div>
            </div>



        </>
    )

}

export default React.memo(MapView)